import { render, staticRenderFns } from "./BrandUserProfile.vue?vue&type=template&id=fdb428d2"
import script from "./BrandUserProfile.vue?vue&type=script&lang=js"
export * from "./BrandUserProfile.vue?vue&type=script&lang=js"
import style0 from "./BrandUserProfile.vue?vue&type=style&index=0&id=fdb428d2&prod&lang=sass"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports